export const organizationSettingsFrag = `
    id
    organizationId
    key
    data
    active
    createdAt
    updatedAt
`;
